import { render, staticRenderFns } from "./Bilty.vue?vue&type=template&id=c88e736e&"
import script from "./Bilty.vue?vue&type=script&lang=js&"
export * from "./Bilty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports